<template lang="pug">
.d-flex.flex-wrap
  v-chip.mr-2.my-1(
    v-for="(project, index) in (projects || [])"
    :key="project.id || index"
    label
    color="accent"
    :close="showActions"
    @click:close="$emit('delete', project.id)"
  ) {{ project.name }}

  v-tooltip(v-if="showActions" bottom)
    template(#activator="{ on }")
      v-btn.my-1.mx-2.rounded(@click="$emit('open')" v-on="on" label fab tile x-small color="success")
        v-icon mdi-plus
    span Добавить проект
</template>

<script>
export default {
  props: {
    projects: { type:Array, required:true },
    showActions:{ type:Boolean, required: false, default:true },
  },

};
</script>

<style>

</style>
